import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogOut } from 'lucide-react';
import ParticlesBackground from './ParticlesBackground';
import {
  SuperAdminLayoutContainer,
  Header,
  HeaderContent,
  Logo,
  UserSection,
  UserName,
  LogoutButton,
  MainContent,
  FloatingElement
} from './SuperAdminLayout.styles';

const SuperAdminLayout = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <SuperAdminLayoutContainer>
      <ParticlesBackground />
      
      <FloatingElement delay="0s" />
      <FloatingElement delay="3s" />
      <FloatingElement delay="6s" />

      <Header>
        <HeaderContent>
          <Logo>Super Admin Portal</Logo>
          <UserSection>
            <UserName>Welcome, Super Admin</UserName>
            <LogoutButton onClick={handleLogout}>
              <LogOut size={18} />
              Logout
            </LogoutButton>
          </UserSection>
        </HeaderContent>
      </Header>

      <MainContent>
        <Outlet />
      </MainContent>
    </SuperAdminLayoutContainer>
  );
};

export default SuperAdminLayout;

